export default __webpack_public_path__ + "static/media/dd.570b8bb6.jpg";